module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basis-overview text-dark"
  }, [_c('div', {
    staticClass: "basis-overview__header"
  }, [_c('h1', [_vm._v("Basis Hours")]), _vm._v(" "), _c('div', {
    staticClass: "basis-overview__dates"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "do-spinner"
  }) : _vm._e(), _vm._v(" "), _c('Tabs', {
    attrs: {
      "tabs": [{
        id: 'hours',
        title: 'Hours'
      }, {
        id: 'minutes',
        title: 'Minutes'
      }],
      "selected": _vm.theSelectedTab
    },
    on: {
      "select": function($event) {
        _vm.theSelectedTab = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isDownloading
    },
    on: {
      "click": _vm.asyncLoadXLSXAndDownload
    }
  }, [_vm._v("Download\n        to excel\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "do-button__multiple"
  }, [_c('button', {
    staticClass: "do-button__multiple__bttn icon-arrow-left4",
    on: {
      "click": _vm.setPrevWeek
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-button__multiple__bttn",
    class: {
      'bttn--disabled': _vm.isThisWeek
    },
    on: {
      "click": _vm.setThisWeek
    }
  }, [_vm._v("This\n          week\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-button__multiple__bttn icon-arrow-right4",
    on: {
      "click": _vm.setNextWeek
    }
  })]), _vm._v(" "), _c('DatePickerRange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "basis-overview__body"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.col1), function(col) {
    return _c('th', {
      style: ({
        backgroundColor: col.color ? col.color : null
      }),
      attrs: {
        "rowspan": col.rowspan ? col.rowspan : 1,
        "colspan": col.colspan ? col.colspan : 1
      }
    }, [_c('div', [_vm._v("\n            " + _vm._s(col.name) + "\n          ")])])
  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.col2), function(col) {
    return _c('th', {
      style: ({
        backgroundColor: col.color ? col.color : null
      }),
      attrs: {
        "rowspan": col.rowspan ? col.rowspan : 1,
        "colspan": col.colspan ? col.colspan : 1
      }
    }, [_vm._v("\n          " + _vm._s(col.name) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.usersWithVEvents), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.employee_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEdit(user, user.v_presence, 'weeklyHours', $event)
        }
      }
    }, [_vm._v("\n          " + _vm._s(user.v_presence) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_subject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_break))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_tasks))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_preparation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_substitute_teaching))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_substitute_not_teaching))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_hours_left))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.v_absence))])])
  }), 0)]), _vm._v(" "), (_vm.theEditNumberUser) ? _c('div', {
    ref: "popper_child",
    staticClass: "popper_child"
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [(_vm.isDropdownPopperDone) ? _c('div', {
    staticClass: "number__input-opened"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.theEditNumberNumber),
      expression: "theEditNumberNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeEditing),
      expression: "closeEditing"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.theEditNumberNumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doneEditing.apply(null, arguments)
      },
      "change": function($event) {
        _vm.theEditNumberNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--primary",
    class: {
      'bttn--small--loading': _vm.isUpdatingNumber
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doneEditing.apply(null, arguments)
      }
    }
  }, [(!_vm.isUpdatingNumber) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55ed903a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasisPrimary/BasisOverview.vue
// module id = 1926
// module chunks = 1